<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">{{ 'OFFER_MULTIPLE_CLIENTS.MODAL_TITLE' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body p-0 d-flex">
  <div class="flex-grow-1" *ngIf="currentStep === 1">
    <div class="top">
      <kendo-grid
        [data]="roomsGridData"
        [pageSize]="roomsResponse?.meta.per_page"
        [sortable]="true"
        [filterable]="true"
        [columnMenu]="false"
        [filter]="roomsState?.filter"
        [sort]="roomsState?.sort"
        [skip]="roomsState?.skip"
        [pageable]="true"
        (dataStateChange)="loadRoomsData($event)"
        [style.height]="'100%'"
        [selectable]="selectableSettings"
        [kendoGridSelectBy]="mySelectionKey"
        [selectedKeys]="selectedRooms"
        [loading]="roomsLoading"
      >
        <kendo-grid-checkbox-column
          [width]="45"
          showSelectAll="true"
          class="text-center p-1"
          headerClass="text-center p-1"
        >
        </kendo-grid-checkbox-column>

        <kendo-grid-column
          [width]="70"
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NUMBER' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ rowIndex + 1 }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.events"
          title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS' | translate }}"
          [filterable]="false"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span *ngFor="let event of dataItem.booking?.events; let i = index">
              <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
                {{ event.formattedName }}
              </a>
              <span *ngIf="i !== dataItem.booking?.events?.length - 1">, </span>
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.property.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.PROPERTY' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'booking_properties'"
              [field]="'booking.property_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.booking.property"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.cancellation_terms.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CANCELLATION_TERMS' | translate }}"
          [width]="130"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'booking_cancellation_terms'"
              [field]="'booking.cancellation_terms_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.booking.cancellation_terms"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="count"
          filter="numeric"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ROOMS_COUNT' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">
            </kendo-grid-numeric-filter-cell>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="type.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.TYPE' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.type"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="meal_plan.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.MEAL_PLAN_SHORT' | translate }}"
          [width]="90"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'room_meal_plans'"
              [field]="'meal_plan_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.meal_plan"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="check_in"
          filter="date"
          format="{0:dd/MM/yyyy}"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_IN' | translate }}"
          [width]="160"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell
              [column]="column"
              [filter]="filter"
              operator="eq"
            ></kendo-grid-date-filter-cell>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.check_in | date : env.pipeDateFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="check_out"
          filter="date"
          format="{0:dd/MM/yyyy}"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_OUT' | translate }}"
          [width]="160"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell
              [column]="column"
              [filter]="filter"
              operator="eq"
            ></kendo-grid-date-filter-cell>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.check_out | date : env.pipeDateFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="net_price"
          [filterable]="false"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NET_PRICE_AVG' | translate }}"
          [width]="110"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>
              {{ dataItem.getAvgNetPrice() }}
              <app-currency-box [currency]="(dataItem?.nights)[0].net_price_currency"></app-currency-box>
            </div>
            <app-currency-converter
              [value]="dataItem.getAvgNetPrice()"
              [fromCurrency]="(dataItem?.nights)[0].net_price_currency"
            >
            </app-currency-converter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="price"
          [filterable]="false"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.PRICE_AVG' | translate }}"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>
              {{ dataItem.getAvgPrice() }}
              <app-currency-box [currency]="(dataItem?.nights)[0].price_currency"></app-currency-box>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="margin"
          [filterable]="false"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.MARGIN_AVG' | translate }}"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ dataItem.getAvgMargin() }} {{ 'DEFAULT_CURRENCY' | translate }}</div>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-input></kendo-pager-input>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
          <app-kendo-grid-refresh-button (click)="loadRoomsData(roomsState)"></app-kendo-grid-refresh-button>
        </ng-template>
      </kendo-grid>
    </div>

    <div class="bottom">
      <kendo-grid [data]="selectedRooms" [columnMenu]="false" [pageable]="false" [style.height]="'100%'">
        <kendo-grid-column
          [width]="70"
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NUMBER' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ rowIndex + 1 }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.events"
          title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS' | translate }}"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-event-select [filter]="filter" [field]="'event_id'"></app-kendo-event-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span *ngFor="let event of dataItem.booking?.events; let i = index">
              <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
                {{ event.formattedName }}
              </a>
              <span *ngIf="i !== dataItem.booking?.events?.length - 1">, </span>
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.property.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.PROPERTY' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'booking_properties'"
              [field]="'booking.property_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.booking.property"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="booking.cancellation_terms.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CANCELLATION_TERMS' | translate }}"
          [width]="130"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'booking_cancellation_terms'"
              [field]="'booking.cancellation_terms_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.booking.cancellation_terms"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="count"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ROOMS_COUNT' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">
            </kendo-grid-numeric-filter-cell>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="type.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.TYPE' | translate }}"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.type"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="meal_plan.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.MEAL_PLAN_SHORT' | translate }}"
          [width]="90"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'room_meal_plans'"
              [field]="'meal_plan_id'"
              [filter]="filter"
            ></app-kendo-type-select>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.meal_plan"></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="check_in"
          format="{0:dd/MM/yyyy}"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_IN' | translate }}"
          [width]="160"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell
              [column]="column"
              [filter]="filter"
              operator="eq"
            ></kendo-grid-date-filter-cell>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.check_in | date : env.pipeDateFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="check_out"
          format="{0:dd/MM/yyyy}"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_OUT' | translate }}"
          [width]="160"
        >
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-date-filter-cell
              [column]="column"
              [filter]="filter"
              operator="eq"
            ></kendo-grid-date-filter-cell>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.check_out | date : env.pipeDateFormat }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="net_price"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NET_PRICE_AVG' | translate }}"
          [width]="110"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>
              {{ dataItem.getAvgNetPrice() }}
              <app-currency-box [currency]="(dataItem?.nights)[0].net_price_currency"></app-currency-box>
            </div>
            <app-currency-converter
              [value]="dataItem.getAvgNetPrice()"
              [fromCurrency]="(dataItem?.nights)[0].net_price_currency"
            >
            </app-currency-converter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="price"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.PRICE_AVG' | translate }}"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>
              {{ dataItem.getAvgPrice() }}
              <app-currency-box [currency]="(dataItem?.nights)[0].price_currency"></app-currency-box>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="margin"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.MARGIN_AVG' | translate }}"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ dataItem.getAvgMargin() }} {{ 'DEFAULT_CURRENCY' | translate }}</div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ACTIONS' | translate }}"
          [width]="60"
          [class]="'text-center'"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-delete-button (click)="removeSelectedRoom(dataItem)"></app-delete-button>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>

  <div class="flex-grow-1" *ngIf="currentStep === 2">
    <div class="top">
      <kendo-grid
        [style.height]="'100%'"
        [data]="salesData"
        [pageSize]="salesResponse?.meta.per_page"
        [sortable]="true"
        [filterable]="true"
        [filter]="salesState?.filter"
        [sort]="salesState?.sort"
        [skip]="salesState?.skip"
        [pageable]="true"
        (dataStateChange)="loadSalesData($event)"
        [selectable]="selectableSettings"
        [kendoGridSelectBy]="mySelectionKey"
        [selectedKeys]="selectedSales"
        (selectedKeysChange)="selectedSalesChange(selectedSalesGrid)"
      >
        <kendo-grid-checkbox-column
          [width]="45"
          showSelectAll="true"
          class="text-center p-1"
          headerClass="text-center p-1"
        >
        </kendo-grid-checkbox-column>

        <kendo-grid-column
          [width]="70"
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NUMBER' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ rowIndex + 1 }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="id"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ID' | translate }}"
          filter="numeric"
          [width]="150"
        ></kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="status.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.STATUS' | translate }}"
          filter="text"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'sale_status'"
              [filter]="filter"
              [field]="'status_id'"
            ></app-kendo-type-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.status"></app-type-badge>
            <div class="text-truncate" [ngbTooltip]="dataItem.status_reason" container="body">
              {{ dataItem.status_reason }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="client.name"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CLIENT' | translate }}"
          filter="text"
          [width]="200"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-client-select [filter]="filter"></app-kendo-client-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-client-box [client]="dataItem.client" [targetBlank]="true"></app-client-box>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="event.formattedName"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.EVENT' | translate }}"
          filter="text"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-events-select [filter]="filter" [data]="selectedRooms[0]?.booking?.events">
            </app-kendo-events-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem>
            <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.event?.id }" target="_blank">
              {{ dataItem?.event?.formattedName }}
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="requests"
          [filterable]="false"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.REQUESTS_COUNT' | translate }}"
          [width]="100"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem?.requests?.length }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="requests.status.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CLIENT_REQUESTS_STATUS' | translate }}"
          filter="text"
          [sortable]="false"
          width="150"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'sale_request'"
              [filter]="filter"
              [field]="'requests.status_id'"
            ></app-kendo-type-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge
              *ngFor="let status of dataItem?.requestsUniqueStatuses; let i = index"
              [type]="status"
              class="d-block"
            ></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ACTIONS' | translate }}"
          [width]="60"
          [class]="'text-center'"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-sale-button [link]="['/sales/view']" [params]="{ id: dataItem.id }" [targetBlank]="true">
            </app-sale-button>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-input></kendo-pager-input>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
          <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
          <app-kendo-grid-refresh-button (click)="loadSalesData(salesState)"></app-kendo-grid-refresh-button>
        </ng-template>
      </kendo-grid>
    </div>

    <div class="bottom">
      <kendo-grid
        #selectedSalesGrid
        [style.height]="'100%'"
        [columnMenu]="false"
        [pageable]="false"
        [data]="selectedSales"
      >
        <kendo-grid-column
          [width]="70"
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.NUMBER' | translate }}"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ rowIndex + 1 }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="id"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ID' | translate }}"
          filter="numeric"
          [width]="165"
        ></kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="status.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.STATUS' | translate }}"
          filter="text"
          [width]="120"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-type-select
              [groupType]="'sale_status'"
              [filter]="filter"
              [field]="'status_id'"
            ></app-kendo-type-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge [type]="dataItem.status"></app-type-badge>
            <div class="text-truncate" [ngbTooltip]="dataItem.status_reason" container="body">
              {{ dataItem.status_reason }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="client.name"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CLIENT' | translate }}"
          filter="text"
          [width]="200"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-client-select [filter]="filter"></app-kendo-client-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-client-box [client]="dataItem.client" [targetBlank]="true"></app-client-box>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="event.formattedName"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.EVENT' | translate }}"
          filter="text"
        >
          <ng-template kendoGridFilterCellTemplate let-filter>
            <app-kendo-event-select [filter]="filter"></app-kendo-event-select>
          </ng-template>

          <ng-template kendoGridCellTemplate let-dataItem>
            <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.event?.id }" target="_blank">
              {{ dataItem?.event?.formattedName }}
            </a>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          field="requests.status.value"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.CLIENT_REQUESTS_STATUS' | translate }}"
          [filterable]="false"
          [sortable]="false"
          width="150"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-type-badge
              *ngFor="let request of dataItem?.requests; let i = index"
              [type]="request.status"
              class="d-block"
            ></app-type-badge>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
          class="text-center p-1"
          headerClass="text-center p-1"
          title="{{ 'OFFER_MULTIPLE_CLIENTS.ACTIONS' | translate }}"
          [width]="60"
          [class]="'text-center'"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <app-delete-button (click)="removeSelectedSale(dataItem)"></app-delete-button>
          </ng-template>
        </kendo-grid-column>

        <div *kendoGridDetailTemplate="let dataItemSale">
          <kendo-grid [kendoGridBinding]="selectedRooms">
            <kendo-grid-column [width]="40" class="text-center p-1" headerClass="text-center p-1">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <input type="checkbox" [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['selected']" />
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="70"
              class="text-center p-1"
              headerClass="text-center p-1"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.NUMBER' | translate }}"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{ rowIndex + 1 }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              [width]="150"
              class="text-center p-1"
              headerClass="text-center p-1"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.REQUEST' | translate }}"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <ng-select
                  class="request-select"
                  [items]="dataItemSale.requests"
                  bindLabel="formattedName"
                  bindValue="id"
                  [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['request_id']"
                >
                </ng-select>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="booking.events"
              title="{{ 'HOTELS_BOOKINGS.HOTEL_BOOKINGS_LIST.EVENTS' | translate }}"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter>-->
              <!--                <app-kendo-event-select [filter]="filter" [field]="'event_id'"></app-kendo-event-select>-->
              <!--              </ng-template>-->

              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngFor="let event of dataItem.booking?.events; let i = index">
                  <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
                    {{ event.formattedName }}
                  </a>
                  <span *ngIf="i !== dataItem.booking?.events?.length - 1">, </span>
                </span>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="booking.property.value"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.PROPERTY' | translate }}"
              [width]="120"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter>-->
              <!--                <app-kendo-type-select-->
              <!--                  [groupType]="'booking_properties'"-->
              <!--                  [field]="'booking.property_id'"-->
              <!--                  [filter]="filter"-->
              <!--                ></app-kendo-type-select>-->
              <!--              </ng-template>-->
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <app-type-badge [type]="dataItem.booking.property"></app-type-badge>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="booking.cancellation_terms.value"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.CANCELLATION_TERMS' | translate }}"
              [width]="130"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter>-->
              <!--                <app-kendo-type-select-->
              <!--                  [groupType]="'booking_cancellation_terms'"-->
              <!--                  [field]="'booking.cancellation_terms_id'"-->
              <!--                  [filter]="filter"-->
              <!--                ></app-kendo-type-select>-->
              <!--              </ng-template>-->
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <app-type-badge [type]="dataItem.booking.cancellation_terms"></app-type-badge>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="count"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.ROOMS_COUNT' | translate }}"
              [width]="90"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter let-column="column">-->
              <!--                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">-->
              <!--                </kendo-grid-numeric-filter-cell>-->
              <!--              </ng-template>-->
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="type.value"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.TYPE' | translate }}"
              [width]="120"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter>-->
              <!--                <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>-->
              <!--              </ng-template>-->
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <app-type-select [(model)]="finalData[dataItem.id][dataItemSale.id]['type_id']" [groupType]="'rooms'">
                </app-type-select>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="meal_plan.value"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.MEAL_PLAN_SHORT' | translate }}"
              [width]="70"
            >
              <!--              <ng-template kendoGridFilterCellTemplate let-filter>-->
              <!--                <app-kendo-type-select-->
              <!--                  [groupType]="'room_meal_plans'"-->
              <!--                  [field]="'meal_plan_id'"-->
              <!--                  [filter]="filter"-->
              <!--                ></app-kendo-type-select>-->
              <!--              </ng-template>-->
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <app-type-badge [type]="dataItem.meal_plan"></app-type-badge>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="check_in"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_IN' | translate }}"
              [width]="110"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="form-group">
                  <p-calendar
                    [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['check_in']"
                    [selectOtherMonths]="true"
                    inputStyleClass="form-control"
                    class="prime-ng-datapicker"
                    styleClass="d-block"
                    monthNavigator="true"
                    yearNavigator="true"
                    dateFormat="dd.mm.yy"
                    baseZIndex="1"
                    [required]="finalData[dataItem.id][dataItemSale.id]['selected']"
                    [firstDayOfWeek]="1"
                  ></p-calendar>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="check_out"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.CHECK_OUT' | translate }}"
              [width]="110"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div class="form-group">
                  <p-calendar
                    [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['check_out']"
                    [selectOtherMonths]="true"
                    inputStyleClass="form-control"
                    class="prime-ng-datapicker"
                    styleClass="d-block"
                    monthNavigator="true"
                    yearNavigator="true"
                    dateFormat="dd.mm.yy"
                    baseZIndex="1"
                    [required]="finalData[dataItem.id][dataItemSale.id]['selected']"
                    [firstDayOfWeek]="1"
                  ></p-calendar>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="net_price"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.NET_PRICE_AVG' | translate }}"
              [width]="110"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div>
                  {{ dataItem.getAvgNetPrice() }}
                  <app-currency-box [currency]="(dataItem?.nights)[0].net_price_currency"></app-currency-box>
                </div>
                <app-currency-converter
                  [value]="dataItem.getAvgNetPrice()"
                  [fromCurrency]="(dataItem?.nights)[0].net_price_currency"
                >
                </app-currency-converter>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="price"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.PRICE_AVG' | translate }}"
              [width]="100"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div>
                  {{ dataItem.getAvgPrice() }}
                  <app-currency-box [currency]="(dataItem?.nights)[0].price_currency"></app-currency-box>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              field="margin"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.MARGIN_AVG' | translate }}"
              [width]="100"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <div>{{ dataItem.getAvgMargin() }} {{ 'DEFAULT_CURRENCY' | translate }}</div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.PEOPLE' | translate }}"
              [width]="60"
              [class]="'text-center'"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <input
                  class="form-control"
                  [required]="finalData[dataItem.id][dataItemSale.id]['selected']"
                  [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['people']"
                  [ngModelOptions]="{ standalone: true }"
                />
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.COUNT' | translate }}"
              [width]="60"
              [class]="'text-center'"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <input
                  class="form-control"
                  [required]="finalData[dataItem.id][dataItemSale.id]['selected']"
                  [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['count']"
                  [ngModelOptions]="{ standalone: true }"
                />
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
              class="text-center p-1"
              headerClass="text-center p-1"
              title="{{ 'OFFER_MULTIPLE_CLIENTS.CLIENT_PRICE' | translate }}"
              [width]="100"
              [class]="'text-center'"
            >
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <input
                  class="form-control"
                  [required]="finalData[dataItem.id][dataItemSale.id]['selected']"
                  [(ngModel)]="finalData[dataItem.id][dataItemSale.id]['price']"
                  [ngModelOptions]="{ standalone: true }"
                />
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </kendo-grid>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-between">
  <div>
    <button *ngIf="currentStep === 2" (click)="setCurrentStep(1)" type="button" class="btn btn-outline-dark btn-xs">
      {{ 'OFFER_MULTIPLE_CLIENTS.PREVIOUS' | translate }}
    </button>
  </div>

  <div>
    <button
      *ngIf="currentStep === 1"
      (click)="setCurrentStep(2)"
      type="button"
      class="btn btn-outline-dark btn-xs"
      [disabled]="selectedRooms.length <= 0"
    >
      {{ 'OFFER_MULTIPLE_CLIENTS.NEXT' | translate }}
    </button>

    <div class="d-flex" *ngIf="currentStep === 2">
      <ng-select
        class="event-select"
        [items]="selectedRooms[0]?.booking?.events"
        bindLabel="formattedName"
        bindValue="id"
        [required]="true"
        [(ngModel)]="selectedEventId"
      >
      </ng-select>

      <button [disabled]="!selectedEventId" (click)="save()" type="button" class="btn btn-outline-dark btn-xs ms-2">
        {{ 'OFFER_MULTIPLE_CLIENTS.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
